module.exports = __webpack_public_path__ + "img/Grupo30.58e552c9.png";